<template>
    <div>
         <h2 class="ix-page-title-secondary mt-4">Synthèse du lot</h2>
        <!-- Toute la largeur : quantité, ratio et heures à gauche, tableau des catégories à droite -->
        <div class="row mb-2 mt-2">
            <div class="col-sm-12 col-md-12 col-lg-5">
                <div class="form-group row">
                    <label for="quantity" class="col-sm-4 col-form-label">Quantité</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input type="number" class="form-control prediction-number" v-model="lot.quantity" :id="'lots[' + index + '][quantity]'" :name="'lots[' + index + '][quantity]'" step="0.01" min="0.01" @change="onQuantityChange">
                            <input type="text" class="form-control" v-model="lot.unit" :id="'lots[' + index + '][unit]'"  :name="'lots[' + index + '][unit]'" placeholder="m2, m3, tonnes, kg.." :required="lot.quantity != '' && lot.quantity != null">
                            <!-- Quantité de lot dynamique : les lignes hors forfait suivent la quantité du lot -->
                            <div class="input-group-append" v-if="!isDeal">
                                <button type="button" class="ix-scale-toggle" :class="{'is-active': lot.scale_lines}"
                                    v-b-tooltip.hover.html="scaleTooltip(lot.scale_lines, 'du lot')" :key="'scale-' + lot.scale_lines"
                                    :aria-pressed="lot.scale_lines ? 'true' : 'false'" aria-label="Recalculer les quantités des lignes selon la quantité du lot"
                                    @click="lot.scale_lines = !lot.scale_lines">
                                    <i class="far fa-calculator"></i>
                                </button>
                            </div>
                        </div>
                        <input type="hidden" :name="'lots[' + index + '][scale_lines]'" :value="lot.scale_lines ? 1 : 0" v-if="!isDeal">
                    </div>
                </div>
                <div class="ix-lot-scale-notice" v-if="lastScale">
                    <i class="far fa-sync-alt"></i> Quantité du lot passée de {{ formatNumber(lastScale.from) }} à {{ formatNumber(lastScale.to) }}{{ lot.unit ? ' ' + lot.unit : '' }} : quantités ×{{ formatNumber(lastScale.factor, 4) }}.
                    <button type="button" class="ix-btn link p-0 ml-1" @click="undoScale">Annuler</button>
                </div>
                <div class="form-group row">
                    <label for="total_margin" class="col-sm-4 col-form-label">
                        Ratio
                        <span v-b-tooltip title="PV total / quantité">
                            <i class="fas fa-question-circle"></i>
                        </span>
                    </label>
                        <div class="col-sm-8 text-right">
                        <span class="ix-text-small ix-text-red" v-if="lot.quantity == 0">Impossible de calculer le résultat sur une quantité égale à 0</span>
                        <div v-if="lot.quantity != 0">
                            <span class="ix-text-secondary ix-text-small" v-if="ratio == null">Veuillez saisir une quantité et son unité pour permettre l'affichage du résultat</span>

                            <div v-if="ratio != null">
                                <span class="ix-text-large ix-text-bold">{{ currency(ratio) }}</span> / {{ lot.unit }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="total_margin" class="col-sm-4 col-form-label">
                        Marge dégagée
                        <span v-b-tooltip title="PV total - PR total">
                            <i class="fas fa-question-circle"></i>
                        </span>
                    </label>
                    <div class="col-sm-8 text-right">
                        <span class="ix-text-large ix-text-bold" :class="{ 'ix-text-red': total_margin < 0 }">{{ currency(total_margin) }}</span>
                    </div>
                </div>

                <hr>
                <div class="form-group row">
                    <label for="quantity" class="col-sm-4 col-form-label">Nombre d'heures travaillées</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input type="number" class="form-control prediction-number" v-model="lot.hours_per_day" :id="'lots[' + index + '][hours_per_day]'" :name="'lots[' + index + '][hours_per_day]'" step="0.01" min="0.01" required>
                            <div class="input-group-append">
                                <span class="input-group-text" id="inputGroup-sizing-sm">h / j / personne</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="total_margin" class="col-sm-4 col-form-label">
                        Total d'heures prévisionnelles
                    </label>
                    <div class="col-sm-8 text-right">
                        {{ total_hours }}h soit <span class="ix-text-large ix-text-bold">{{ total_day_man }}j / personne</span>
                    </div>
                </div>

            </div>

            <div class="col-sm-12 col-md-12 col-lg-7">
                <div class="ix-table-box">
                    <table class="ix-table">
                        <thead>
                            <tr>
                                <th style="width: 20px;"></th>
                                <th></th>
                                <th class="text-right">Prix de revient HT</th>
                                <th class="text-center" style="width: 180px;">
                                    Tx {{ lot.margin_type == 2 ? 'marque' : 'marge' }} C.
                                    <span v-b-tooltip title="Marge conseillée">
                                        <i class="fas fa-question-circle"></i>
                                    </span>
                                </th>
                                <th class="text-center">
                                    Tx {{ lot.margin_type == 2 ? 'marque' : 'marge' }} D.
                                    <span v-b-tooltip title="Marge dégagée">
                                        <i class="fas fa-question-circle"></i>
                                    </span>
                                </th>
                                <th class="text-right">Prix de vente HT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">
                                    <i class="far fa-user"></i>
                                </td>
                                <td>
                                    <span class="ix-text-bold">Main d'oeuvre</span>
                                </td>
                                <td class="text-right">{{ currency(total_workforce) }}</td>
                                <td>
                                    <div class="input-group input-group-sm">
                                        <input type="number" class="form-control text-center prediction-number" :class="{ 'text-danger': parseFloat(lot.margin_workforce) < 0 }" :name="'lots[' + index + '][margin_workforce]'" v-model="lot.margin_workforce" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                            <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(1, lot.margin_workforce)" :disabled="lot.margin_workforce === '' || lot.margin_workforce === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (lot.margin_type == 2 ? 'marque' : 'marge')">
                                                <i class="far fa-sync"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span :class="{ 'ix-text-red': avg_margin_workforce < 0 }">{{ avg_margin_workforce }}%</span>
                                </td>
                                <td class="text-right">{{ currency(total_workforce_selling) }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <i class="far fa-shopping-bag"></i>
                                </td>
                                <td>
                                    <span class="ix-text-bold">Achats</span>
                                </td>
                                <td class="text-right">{{ currency(total_purchases) }}</td>
                                <td>
                                    <div class="input-group input-group-sm">
                                        <input type="number" class="form-control text-center prediction-number" :class="{ 'text-danger': parseFloat(lot.margin_purchases) < 0 }" :name="'lots[' + index + '][margin_purchases]'" v-model="lot.margin_purchases" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                            <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(2, lot.margin_purchases)" :disabled="lot.margin_purchases === '' || lot.margin_purchases === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (lot.margin_type == 2 ? 'marque' : 'marge')">
                                                <i class="far fa-sync"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span :class="{ 'ix-text-red': avg_margin_purchases < 0 }">{{ avg_margin_purchases }}%</span>
                                </td>
                                <td class="text-right">{{ currency(total_purchases_selling) }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <i class="far fa-cube"></i>
                                </td>
                                <td>
                                    <span class="ix-text-bold">Stocks</span>
                                </td>
                                <td class="text-right">{{ currency(total_stocks) }}</td>
                                <td>
                                    <div class="input-group input-group-sm">
                                        <input type="number" class="form-control text-center" :class="{ 'text-danger': parseFloat(lot.margin_stocks) < 0 }" :name="'lots[' + index + '][margin_stocks]'" v-model="lot.margin_stocks" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                            <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(3, lot.margin_stocks)" :disabled="lot.margin_stocks === '' || lot.margin_stocks === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (lot.margin_type == 2 ? 'marque' : 'marge')">
                                                <i class="far fa-sync"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span :class="{ 'ix-text-red': avg_margin_stocks < 0 }">{{ avg_margin_stocks }}%</span>
                                </td>
                                <td class="text-right">{{ currency(total_stocks_selling) }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <i class="far fa-cog"></i>
                                </td>
                                <td>
                                    <span class="ix-text-bold">Matériels</span>
                                </td>
                                <td class="text-right">{{ currency(total_equipments) }}</td>
                                <td>
                                    <div class="input-group input-group-sm">
                                        <input type="number" class="form-control text-center prediction-number" :class="{ 'text-danger': parseFloat(lot.margin_equipments) < 0 }" :name="'lots[' + index + '][margin_equipments]'" v-model="lot.margin_equipments" required :min="marginBounds.min" :max="marginBounds.max" step="0.01">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                            <button class="ix-btn ix-btn-icon transparent" type="button" @click="updatePredictionsMargin(4, lot.margin_equipments)" :disabled="lot.margin_equipments === '' || lot.margin_equipments === null" :title="'Mettre à jour les prévisions de la catégorie avec ce taux de ' + (lot.margin_type == 2 ? 'marque' : 'marge')">
                                                <i class="far fa-sync"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span :class="{ 'ix-text-red': avg_margin_equipments < 0 }">{{ avg_margin_equipments }}%</span>
                                </td>
                                <td class="text-right">{{ currency(total_equipments_selling) }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="ix-text-bold">{{ optionalCount > 0 ? 'Total sans option' : 'Total' }}</td>
                                <td class="text-right ix-text-bold">
                                    {{ currency(total) }}
                                </td>
                                <td></td>
                                <td class="text-center">
                                    <span :class="{ 'ix-text-red': avg_margin < 0 }">{{ avg_margin }}%</span>
                                    <input type="hidden" :name="'lots[' + index + '][margin_type]'" v-model="lot.margin_type">
                                </td>
                                <td class="text-right ix-text-large ix-text-bold">
                                    {{ currency(total_selling) }}
                                </td>
                            </tr>
                            <tr v-if="optionalCount > 0">
                                <td class="text-center">
                                    <i class="far fa-plus-circle"></i>
                                </td>
                                <td class="ix-text-bold">Total optionnel <span class="ix-badge optional ml-1">{{ optionalCount }} option{{ optionalCount > 1 ? 's' : '' }}</span></td>
                                <td class="text-right">{{ currency(total_optional) }}</td>
                                <td></td>
                                <td class="text-center">
                                    <span :class="{ 'ix-text-red': avg_optional_margin < 0 }">{{ avg_optional_margin }}%</span>
                                </td>
                                <td class="text-right">{{ currency(total_optional_selling) }}</td>
                            </tr>
                            <tr v-if="optionalCount > 0">
                                <td></td>
                                <td class="ix-text-bold">Total général</td>
                                <td class="text-right ix-text-bold">{{ currency(total + total_optional) }}</td>
                                <td></td>
                                <td class="text-center">
                                    <span :class="{ 'ix-text-red': avg_margin_with_options < 0 }">{{ avg_margin_with_options }}%</span>
                                </td>
                                <td class="text-right ix-text-large ix-text-bold">{{ currency(total_selling + total_optional_selling) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Swal from "sweetalert2";
import { marginBounds } from "./marginBounds";
import { scaleLines as scalePredictionLines, undoScale as undoPredictionScale, scaleTooltip } from "./scaleLines";

export default {
    name: 'prediction-lot-synthesis-form',
    props: ['lot', 'index', 'isDeal', 'predictionTypes', 'refs', 'hoursByDay'],
    data(){
        return {
            // Dernier recalcul des lignes : quantités d'avant, pour l'annuler
            lastScale: null,
        }
    },
    watch: {
        // Option cochée après avoir changé la quantité : les lignes sont recalculées sur l'écart
        'lot.scale_lines': function(checked) {
            if (checked) {
                this.scaleLines();
            }
        },
    },
    mounted() {
        // Quantité du lot à laquelle correspondent les quantités des lignes (portée par le lot)
        this.$set(this.lot, 'scale_base', this.lot.quantity);
    },
    methods: {
        scaleTooltip,
        formatNumber: function(value, decimals) {
            return (parseFloat(value) || 0).toLocaleString('fr-FR', {maximumFractionDigits: decimals || 3});
        },
        // Option cochée : la nouvelle quantité du lot multiplie les prestations et les lignes hors forfait.
        // Option décochée : la quantité ne sert qu'au ratio ; cocher l'option ensuite applique l'écart
        onQuantityChange: function() {
            if (this.lot.scale_lines) {
                this.scaleLines();
            }
        },
        scaleLines: function() {
            var before = parseFloat(this.lot.scale_base);
            var after = parseFloat(this.lot.quantity);

            if (!(after > 0)) {
                return;
            }

            if (!(before > 0) || before === after) {
                this.lot.scale_base = this.lot.quantity;
                return;
            }

            this.lot.scale_base = this.lot.quantity;

            var factor = after / before;
            var snapshot = scalePredictionLines(this, this.lot.predictions, factor);

            this.lastScale = {from: before, to: after, factor: factor, snapshot: snapshot};
        },
        // Rétablit les quantités d'avant le dernier recalcul et l'ancienne quantité du lot
        undoScale: function() {
            if (!this.lastScale) {
                return;
            }

            undoPredictionScale(this, this.lastScale.snapshot);
            this.lot.quantity = this.lastScale.from;
            this.lot.scale_base = this.lot.quantity;
            this.lastScale = null;
        },
         updatePredictionsMargin: function(type, margin) {
                var types = JSON.parse(this.predictionTypes)
                var selectedType = types.find((t) => {
                    return t.value == type
                })

                if (selectedType != undefined) {
                    Swal.fire({
                        title: 'Êtes-vous sûr ?',
                        text: "L'ensemble des taux de " + (this.lot.margin_type == 2 ? 'marque' : 'marge') + " des prévisions de la catégorie " + selectedType.label.toLowerCase() + " passeront à " + margin + "%",
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Continuer',
                        reverseButtons: true,
                        heightAuto: false
                    }).then((result) => {
                        if (result.value) {
                            this.lot.predictions.filter(prediction => { return prediction.type == type }).forEach(prediction => {
                                this.refs[prediction.uniq][0].updateMargin(margin)
                            })
                        }
                    })
                }
            },
        getPredictionsAttributeSumByType: function (type, attribute) {
            var sum = 0;
            this.baseLines.filter(prediction => { return prediction.type == type && !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction[attribute]));
            return sum;
        },
        /** Taux de marge ou de marque selon le type de marge du lot. */
        marginRate: function (totalHt, totalSelling) {
            var divider = this.lot.margin_type == 2 ? parseFloat(totalSelling) : parseFloat(totalHt);
            if (divider == 0) return 0;
            return this.roundCurrency(((totalSelling - totalHt) / divider) * 100, 2);
        },
        computeAvgMarginsByType: function (type) {
            let totalHt = this.getPredictionsAttributeSumByType(type, 'total');
            let totalSelling = this.getPredictionsAttributeSumByType(type, 'total_selling');

            if (this.lot.margin_type == 2) {
                if (parseFloat(totalSelling) == 0) return 0;

                return this.roundCurrency(
                    ((totalSelling - totalHt) / totalSelling) * 100,
                    2
                );
            }

            if (parseFloat(totalHt) == 0) return 0;

            return this.roundCurrency(
                ((totalSelling - totalHt) / totalHt) * 100,
                2
            );
        }
    },
    computed: {
        marginBounds: function() {
            return marginBounds(this.lot.margin_type);
        },
        lines: function() {
            return this.lot.predictions.concat(this.lot.dilution_lines || []);
        },
        // Les prévisions optionnelles du lot sont chiffrées à part ; les lignes de dilution comptent
        baseLines: function() {
            return this.lines.filter(prediction => !prediction.is_optional);
        },
        optionalLines: function() {
            return this.lines.filter(prediction => prediction.is_optional && !prediction.is_title);
        },
        optionalCount: function() {
            return this.optionalLines.filter(prediction => prediction.designation).length;
        },
        total_optional: function() {
            var sum = 0;
            this.optionalLines.forEach(prediction => sum += parseFloat(prediction.total || 0));
            return sum;
        },
        total_optional_selling: function() {
            var sum = 0;
            this.optionalLines.forEach(prediction => sum += parseFloat(prediction.total_selling || 0));
            return sum;
        },
        avg_optional_margin: function() {
            return this.marginRate(this.total_optional, this.total_optional_selling);
        },
        avg_margin_with_options: function() {
            return this.marginRate(this.total + this.total_optional, this.total_selling + this.total_optional_selling);
        },
        total_selling: function() {
            var sum = 0;
            this.baseLines.filter(prediction => { return !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction.total_selling));
            return sum;
        },
        ratio: function() {
            if (this.lot.quantity && this.lot.unit) {
                return this.total_selling / this.lot.quantity;
            }

            return null;
        },
        total_margin: function() {
            return this.total_selling - this.total
        },
        total: function() {
            var sum = 0;
            this.baseLines.filter(prediction => { return !prediction.is_title }).forEach(prediction => sum += parseFloat(prediction.total));
            return sum;
        },
        total_hours: function() {
            var sum = 0;
            // Les heures : prévisions du lot hors options (la quantité d'une ligne de dilution est un pourcentage)
            this.lot.predictions.filter(prediction => { return !prediction.is_title && !prediction.is_optional && prediction.type == 1 }).forEach(prediction => sum += parseFloat(prediction.quantity));
            return sum;
        },
        total_day_man: function() {
            return this.roundCurrency(this.total_hours / this.lot.hours_per_day, 2)
        },
        // Main d'oeuvre
        total_workforce: function() {
            return this.getPredictionsAttributeSumByType(1, 'total');
        },
         avg_margin_workforce: function() {
            return this.computeAvgMarginsByType(1);
        },
        total_workforce_selling: function() {
            return this.getPredictionsAttributeSumByType(1, 'total_selling');
        },
        // Achat
        total_purchases: function() {
            return this.getPredictionsAttributeSumByType(2, 'total');
        },
        avg_margin_purchases: function() {
            return this.computeAvgMarginsByType(2);
        },
        total_purchases_selling: function() {
            return this.getPredictionsAttributeSumByType(2, 'total_selling');
        },
         // Stock
        total_stocks: function() {
            return this.getPredictionsAttributeSumByType(3, 'total');
        },
        avg_margin_stocks: function() {
            return this.computeAvgMarginsByType(3);
        },
        total_stocks_selling: function() {
            return this.getPredictionsAttributeSumByType(3, 'total_selling');
        },
        // Matériel
        total_equipments: function() {
            return this.getPredictionsAttributeSumByType(4, 'total');
        },
        avg_margin_equipments: function() {
            return this.computeAvgMarginsByType(4);
        },
        total_equipments_selling: function() {
            return this.getPredictionsAttributeSumByType(4, 'total_selling');
        },
        avg_margin: function() {
            if (this.lot.margin_type == 2) {
                if (parseFloat(this.total_selling) != 0) {
                    var divider = parseFloat(this.total_selling);
                } else {
                    return 0;
                }
            } else {
                if (parseFloat(this.total) != 0) {
                    var divider = parseFloat(this.total);
                } else {
                    return 0;
                }
            }

            return this.roundCurrency((this.total_margin/divider) * 100, 2)
        },
    }
}
</script>

<style>

@media screen and (max-width: 1400px){
     .prediction-number{
        min-width: 20px !important;
        width: 40px !important;
    }
}
   
</style>